<template>
  <v-container  style="max-width:1800px">
    <v-card class="ma-4">
      <v-toolbar color="primary" dark>
        Montagem
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center" class="ma-4">
        <v-col>
          <p style="font-size: 20px">
            Módulos no sistema :{{ solarPlant.nModules }}
          </p>
          <p style="font-size: 20px">
            Estrutura para {{ nModuleMountings }} módulos

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  v-show="nModuleMountings !== solarPlant.nModules"
                  style="color: red; font-size: 30px"
                  >mdi-alert</v-icon
                >
              </template>
              <span>Quantidade de estruturas diferente do sistema</span>
            </v-tooltip>
          </p>
        </v-col>
        <!-- <v-spacer></v-spacer> -->

        <v-col>
          <v-btn
            :disabled = "disabled"
            style=""
            class="ma-4"
            color="primary"
            dark
            @click="addmounting"
          >
            +Nova fileira
          </v-btn>
        </v-col>
      </v-row>
      <div v-for="(mounting, index) in mountings" v-bind:key="mounting.id">
        <assembly-canvas
          @remove="remove"
          :disabled = "disabled"
          v-bind:index="index"
          v-bind:mounting="mounting"
          v-on:updated="calcTotal"
          :structures="structures"
        >
        </assembly-canvas>
      </div>
      <v-row class="">
        <v-spacer></v-spacer>
        <v-btn class="primary ma-4"   :disabled = "disabled"  @click="recalc">Recalcular materiais</v-btn>
      </v-row>
    </v-card>


  </v-container>
</template>

<script>
import AssemblyCanvas from "./AssemblyCanvas";
import Module from '../../../../libraries/classes/devices/Module';
import Mounting from "@/libraries/classes/devices/Mounting";

export default {
  components: {
    AssemblyCanvas,
  },
  name: "assembly-card",
  props: ["mountings", "structures", "solarPlant", "disabled", "module","strucure"],

  mounted: function () {},
  methods: {
    recalc(){
      this.$emit('recalc')
    },
    addmounting() {
      //alert("add")
      // this.mountings.push({
      //   module: { altura: 1960, largura: 990 },
      //   type: this.telhado,
      //   quantity: 1,
      //   orientation: "portrait",
      //   nModules: 0,
      //   materiais: {},
      //   listaMateriais: [],
      // });

      // for (var m = 0; m < this.solarPlant.mountings.length; m++) {
      // this.solarPlant.mountings[m].structure = this.structures.find(
      //   (element) => element.id == newMounting.structureId
      // );

      var mountingModule = new Module();
      mountingModule.clone(this.solarPlant.modules[0]);
      
      // mountingModule.quantity = 1;
      // this.solarPlant.mountings[m].module = mountingModule;
      // this.solarPlant.mountings[m].nModules = this.solarPlant.nModules;
      // this.solarPlant.mountings[m].module.quantity = this.solarPlant.nModules;

      // var newMounting = {
      //   orientation:"portrait",
      //   quantity:1,
      //     structureId:"arnJNWFUOQausNSWrAuA",
      //     structure: {},
      //     module:mountingModule,
      //     nModules:0,
      // }
      var newMounting = new Mounting();
      console.log(JSON.stringify(this.solarPlant.structure))
        console.log(JSON.stringify(this.solarPlant.structure.id))


      if(this.solarPlant.strucure){
        
        newMounting.structure = this.structures.find(
          (element) => element.id == newMounting.structureId
        );
     
      }else{
             console.log(JSON.stringify(this.solarPlant.structure.id))
        newMounting.structureId =this.solarPlant.structure.id;
          newMounting.structure = this.solarPlant.strucure;
           
       
      }
     


      newMounting.module = mountingModule;

      this.solarPlant.mountings.push(newMounting);
      // }
    },
    remove(index) {
      this.mountings = this.mountings.splice(index, 1);
    },

    calcTotal() {
      this.nModuleMountings = 0;
      for (var m = 0; m < this.mountings.length; m++) {
        //alert("this.mountings[m].quantity:" + this.mountings[m].quantity)
        //alert("this.mountings[m].nModules:"  +this.mountings[m].nModules)
        this.nModuleMountings +=
          this.mountings[m].quantity * this.mountings[m].nModules;
      }

      this.$emit("updated");
    },
  },
  data() {
    return {
      nModuleMountings: 0,
      total: 0,
      //teste:10,
      //configs:{},
    };
  },
};
</script>
